<template>
  <v-row justify="center" v-if="show">
    <v-dialog v-model="show" max-width="600px" persistent>
      <v-card>
        <v-card-title style="justify-content: center;">{{ $t("token.isExpired") }}</v-card-title>
        <v-card-text class="pb-0 text-center">{{ $t("token.refresh")}}</v-card-text>
        <v-card-actions class="pa-0 mt-4">
          <v-btn
              color="primary"
              tile
              @click="loadRefresh()"
              style="width: 100%;"
          >{{$t('token.loadRefresh')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'RefreshDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods:{
    loadRefresh() {
      window.location.reload()
    }
  }
}
</script>
